import { SplitFactory } from '@splitsoftware/splitio';

let client;
let readyPromise;
let currentKey;

const initClient = (key) => {
  // Avoid re-initializing if the key (e.g., user ID) hasn't changed.
  if (currentKey === key) {
    return;
  }
  currentKey = key;

  if (client) {
    // Destroy the existing client before creating a new one for the new user.
    client.destroy().catch((err) => console.error('Error destroying Split client', err));
  }

  const factory = SplitFactory({
    core: {
      authorizationKey: process.env.SPLIT_IO_KEY,
      key,
    },
    // It's good practice to have a timeout for the SDK readiness.
    startup: {
      readyTimeout: 1.5, // 1.5 seconds
    },
  });

  client = factory.client();

  readyPromise = new Promise((resolve) => {
    client.on(client.Event.SDK_READY, () => resolve());
    client.on(client.Event.SDK_READY_TIMED_OUT, () => {
      console.warn('Split.io SDK timed out. It will return "control" for all treatments.');
      resolve();
    });
  });
};

// Initialize with a guest key on module load for non-authenticated users.
initClient('GUEST');

export const featureFlagService = {
  init: initClient,
  getTreatment: async (flagName) => {
    await readyPromise;
    return client.getTreatment(flagName);
  },
};
